import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ModalEl } from "common/components/modal";
import { InputEl } from "common/components/input";
import { InputType } from "common/components/input/types";
import { BannerEl } from "common/components/banner";
import { BannerTheme, BannerType } from "common/components/banner/types";
import { SelectEl } from "common/components/select";
import { InputLabelEl } from "common/components/input/label";
import { Sentiment } from "./types";
function SentimentButton({ sentiment, cmp }) {
  return /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".sentiment-button",
    attrs: {
      theme: ButtonTheme.Select,
      pressed: cmp.state.sentiment === sentiment,
      icon: sentiment === Sentiment.Positive ? `thumbs-up` : `thumbs-down`
    },
    on: { click: () => cmp.update({ sentiment }) }
  }, sentiment === Sentiment.Positive ? `Yes` : `No`);
}
export function template() {
  const FeedbackPrompt = () => {
    const isSubmitDisabled = this.state.saving || !this.state.feedback && !this.state.sentiment;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".content"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".title"
    }, this.attr(`title`)), this.state.submitErrorMsg && /* @__PURE__ */ jsx(BannerEl, {
      attrs: {
        theme: BannerTheme.Error,
        type: BannerType.Embedded,
        "body-text": `Failed to submit feedback: ${this.state.submitErrorMsg}`
      }
    }), /* @__PURE__ */ jsx("div", {
      sel: ".sentiment"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".sentiment-prompt"
    }, "Was this page helpful?"), /* @__PURE__ */ jsx("div", {
      sel: ".sentiment-controls"
    }, /* @__PURE__ */ jsx(SentimentButton, {
      sentiment: Sentiment.Positive,
      cmp: this
    }), /* @__PURE__ */ jsx(SentimentButton, {
      sentiment: Sentiment.Negative,
      cmp: this
    }))), this.attr(`is-staff-user`) ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".customer-email-input"
    }, /* @__PURE__ */ jsx(InputEl, {
      attrs: {
        type: InputType.Text,
        label: `Customer email (optional)`,
        placeholder: `Customer's email if submitting feedback on their behalf.`
      },
      props: { value: this.state.customerEmail },
      on: { input: this.handleCustomerEmailInput }
    })), /* @__PURE__ */ jsx("div", {
      sel: ".feedback-type-select"
    }, /* @__PURE__ */ jsx(InputLabelEl, {
      attrs: {
        label: `Feedback type`
      }
    }), /* @__PURE__ */ jsx(SelectEl, {
      attrs: {
        "menu-width": 300
      },
      props: {
        sections: this.getFeedbackTypeSections()
      },
      on: {
        change: (ev) => this.handleSelectFeedbackType(ev.detail.item)
      }
    }))) : null, /* @__PURE__ */ jsx("div", {
      sel: ".feedback-input"
    }, /* @__PURE__ */ jsx(InputEl, {
      attrs: {
        type: InputType.TextArea,
        placeholder: this.attr(`placeholder`)
      },
      props: { value: this.state.feedback },
      on: { input: this.handleFeedbackInput }
    }))), /* @__PURE__ */ jsx("div", {
      sel: ".actions"
    }, /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".cancel-btn",
      attrs: {
        theme: ButtonTheme.Tertiary,
        role: `button`
      },
      on: { click: () => this.closeModal(false) }
    }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
      sel: ".submit-btn",
      attrs: {
        theme: ButtonTheme.Primary,
        disabled: isSubmitDisabled,
        icon: this.state.saving ? `spinner` : ``,
        style: isSubmitDisabled ? `pointer-events: none;` : ``
      },
      on: { click: this.submitFeedback }
    }, this.state.saving ? `Sending...` : this.attr(`submit-button-text`))));
  };
  return /* @__PURE__ */ jsx(ModalEl, {
    sel: ".feedback-modal",
    attrs: { open: true, closeable: true, "grow-to-content": true },
    on: { change: this.handleModalChange }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".body"
  }, /* @__PURE__ */ jsx(FeedbackPrompt, null)));
}
